'use es6';

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import H2 from 'UIComponents/elements/headings/H2';
import H3 from 'UIComponents/elements/headings/H3';
import ClickableHeader from '../../Header/ClickableHeader';
import Doc from './Doc';
import Oas from '../../../lib/api-explorer/models/Oas';
import { setLanguage } from '../actions';
import { getDefaultLanguage } from '../selectors/LanguageSelectors';
import { getFilteredOasDocs, getSectionHeadings } from '../selectors/DocSelectors';
import { stringToId } from '../../../utils/urls';
import NewDoc from './NewDoc';
import EndpointSelect from './EndpointSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApiExplorerH2 = styled(ClickableHeader).withConfig({
  displayName: "ApiExplorer__ApiExplorerH2",
  componentId: "vnbw4o-0"
})(["padding:20px 0 0 0;"]);
class ApiExplorer extends Component {
  constructor(props) {
    super(props);
    this.setLanguage = language => {
      this.setState({
        language
      });
      setLanguage(language);
    };
    this.changeSelected = selected => {
      this.setState({
        selectedApp: {
          selected,
          changeSelected: this.changeSelected
        }
      });
    };
    this.maybeRenderSectionHeading = (slug, renderedTagNames, sectionHeadings) => {
      const {
        newLayout
      } = this.props;
      const sectionHeading = sectionHeadings.find(heading => heading.name === slug);
      if (sectionHeading && renderedTagNames.indexOf(slug) === -1) {
        renderedTagNames.push(slug);
        if (newLayout) {
          // New Docs UI
          return /*#__PURE__*/_jsx(ApiExplorerH2, {
            Component: H2,
            id: stringToId(slug),
            children: slug
          });
        } else {
          // Normal use case
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(H3, {
              id: `section-${slug.replace(' ', '-')}`,
              children: slug
            }), sectionHeading.description && /*#__PURE__*/_jsx("p", {
              children: sectionHeading.description
            })]
          });
        }
      } else {
        return null;
      }
    };
    this.state = {
      language: this.props.language,
      selectedApp: {
        selected: '',
        changeSelected: this.changeSelected
      }
    };
  }
  getOas(doc) {
    // Get the apiSetting id from the following places:
    // - category.apiSetting if set and populated
    // - api.apiSetting if that's a string
    // - api.apiSetting._id if that's set
    // This will return undefined if apiSetting is not set
    const apiSetting = doc.category.apiSetting || typeof doc.api.apiSetting === 'string' && doc.api.apiSetting || typeof doc.api.apiSetting === 'object' && doc.api.apiSetting && doc.api.apiSetting._id;
    return new Oas(this.props.oasFiles[apiSetting]);
  }
  render() {
    const {
      filteredOasDocs,
      oasDocs,
      sectionHeadings,
      newLayout
    } = this.props;
    const renderedTagNames = [];
    return /*#__PURE__*/_jsxs("div", {
      className: `is-lang-${this.state.language}`,
      "data-test-id": "doc",
      children: [!newLayout && /*#__PURE__*/_jsx(EndpointSelect, {
        className: "m-top-4",
        docs: oasDocs,
        sectionHeadings: sectionHeadings.map(o => o.name)
      }), (newLayout ? oasDocs : filteredOasDocs).map(doc => {
        const DocComponent = newLayout ? NewDoc : Doc;
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [sectionHeadings && doc.slug && this.maybeRenderSectionHeading(doc.slug, renderedTagNames, sectionHeadings), /*#__PURE__*/_jsx(DocComponent, {
            doc: doc,
            oasDocs: oasDocs,
            setLanguage: this.setLanguage,
            flags: this.props.flags,
            language: this.state.language,
            newLayout: this.props.newLayout,
            headerId: this.props.headerId
          })]
        }, doc._id);
      })]
    });
  }
}
ApiExplorer.propTypes = {
  filteredOasDocs: PropTypes.arrayOf(PropTypes.object).isRequired,
  oasFiles: PropTypes.shape({}).isRequired,
  sectionHeadings: PropTypes.arrayOf(PropTypes.object).isRequired,
  flags: PropTypes.shape({
    correctnewlines: PropTypes.bool
  }).isRequired,
  language: PropTypes.string.isRequired,
  oasDocs: PropTypes.array.isRequired,
  newLayout: PropTypes.bool,
  headerId: PropTypes.string
};
ApiExplorer.defaultProps = {
  flags: {
    correctnewlines: false
  }
};
const mapStateToProps = state => {
  return {
    filteredOasDocs: getFilteredOasDocs(state),
    sectionHeadings: getSectionHeadings(state),
    language: getDefaultLanguage(state)
  };
};
export default connect(mapStateToProps)(ApiExplorer);